// Social
import Behance from '@narative/gatsby-theme-novela/src/icons/social/Behance.Icon';
import Dribbble from '@narative/gatsby-theme-novela/src/icons/social/Dribbble.Icon';
import DevTo from '@narative/gatsby-theme-novela/src/icons/social/DevTo.Icon';
import Facebook from '@narative/gatsby-theme-novela/src/icons/social/Facebook.Icon';
import Instagram from '@narative/gatsby-theme-novela/src/icons/social/Instagram.Icon';
import Twitter from '@narative/gatsby-theme-novela/src/icons/social/Twitter.Icon';
import LinkedIn from '@narative/gatsby-theme-novela/src/icons/social/LinkedIn.Icon';
import Medium from '@narative/gatsby-theme-novela/src/icons/social/Medium.Icon';
import Notion from '@narative/gatsby-theme-novela/src/icons/social/Notion.Icon';
import Github from '@narative/gatsby-theme-novela/src/icons/social/Github.Icon';
import Stackoverflow from '@narative/gatsby-theme-novela/src/icons/social/Stackoverflow.Icon';
import Unsplash from '@narative/gatsby-theme-novela/src/icons/social/Unsplash.Icon';
import YouTube from '@narative/gatsby-theme-novela/src/icons/social/YouTube.Icon';
import Patreon from '@narative/gatsby-theme-novela/src/icons/social/Patreon.Icon';
import Paypal from '@narative/gatsby-theme-novela/src/icons/social/Paypal.Icon';
import DigitalOcean from '@narative/gatsby-theme-novela/src/icons/social/DigitalOcean.Icon';
import TripAdvisor from '@narative/gatsby-theme-novela/src/icons/social/TripAdvisor.Icon';
import Buymeacoffee from '@narative/gatsby-theme-novela/src/icons/social/Buymeacoffee.Icon';
import Mailto from '@narative/gatsby-theme-novela/src/icons/social/Mailto.Icon';
import Url from '@narative/gatsby-theme-novela/src/icons/social/Url.Icon';
import SGDB from '../../../icons/social/SGDB.Icon';
import Moofy from '../../../icons/social/Moofy.Icon';
import X from '../../../icons/social/X.Icon';
import Mastodon from '../../../icons/social/Mastodon.Icon';
import ArtStation from '../../../icons/social/ArtStation.Icon';

// UI
import ChevronLeft from '@narative/gatsby-theme-novela/src/icons/ui/ChevronLeft.Icon';
import Copied from '@narative/gatsby-theme-novela/src/icons/ui/Copied.Icon';
import Copy from '@narative/gatsby-theme-novela/src/icons/ui/Copy.Icon';
import Ex from '@narative/gatsby-theme-novela/src/icons/ui/Ex.Icon';
import Link from '@narative/gatsby-theme-novela/src/icons/ui/Link.Icon';
import ToggleOpen from '@narative/gatsby-theme-novela/src/icons/ui/ToggleOpen.Icon';
import ToggleClose from '@narative/gatsby-theme-novela/src/icons/ui/ToggleClose.Icon';
import Rows from '@narative/gatsby-theme-novela/src/icons/ui/Rows.Icon';
import Tiles from '@narative/gatsby-theme-novela/src/icons/ui/Tiles.Icon';

export default {
  Behance,
  Dribbble,
  DevTo,
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  Medium,
  Notion,
  Github,
  Stackoverflow,
  Unsplash,
  YouTube,
  Patreon,
  Paypal,
  DigitalOcean,
  TripAdvisor,
  Buymeacoffee,
  Mailto,
  Url,
  SGDB,
  Moofy,
  X,
  Mastodon,
  ArtStation,

  ChevronLeft,
  Copied,
  Copy,
  Ex,
  Link,
  ToggleClose,
  ToggleOpen,
  Rows,
  Tiles,
};
